import { render, staticRenderFns } from "./shift-records.vue?vue&type=template&id=39787e8e&scoped=true&"
import script from "./shift-records.vue?vue&type=script&lang=js&"
export * from "./shift-records.vue?vue&type=script&lang=js&"
import style0 from "./shift-records.vue?vue&type=style&index=0&id=39787e8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39787e8e",
  null
  
)

export default component.exports